import axios from "axios";

// Deliberately NOT services/authService.js: that instance attaches CSRF
// cookies, retries on 401 through the token-refresh flow, and redirects to
// "/" (login) on refresh failure — all wrong for an anonymous recipient
// who was never logged in. This is a bare, credential-less client scoped
// to the three public folder-share endpoints.
const API_URL = process.env.REACT_APP_API_URL || "/api/";

const client = axios.create({
  baseURL: API_URL,
  withCredentials: false,
});

const passwordHeaders = (password) =>
  password ? { "X-Share-Password": password } : {};

export const fetchSharedFolderTree = (token, password) =>
  client.get(`folder-share/${token}/`, {
    headers: passwordHeaders(password),
  });

export const sharedFolderFileUrl = (token, documentId) =>
  `${API_URL.replace(/\/$/, "")}/folder-share/${token}/file/${documentId}/`;

export const sharedFolderZipUrl = (token) =>
  `${API_URL.replace(/\/$/, "")}/folder-share/${token}/zip/`;

// Downloads (file + zip) can't just be an <a href> when a password is set,
// since the gate is a header/body check, not a query param — so we fetch
// the bytes with the password attached and hand the browser a blob to save.
// Anonymous (no password) downloads still go through this path for one
// consistent code path and error handling.
export const downloadSharedFolderFile = (token, documentId, password) =>
  client.get(`folder-share/${token}/file/${documentId}/`, {
    headers: passwordHeaders(password),
    responseType: "blob",
  });

export const downloadSharedFolderZip = (token, password) =>
  client.get(`folder-share/${token}/zip/`, {
    headers: passwordHeaders(password),
    responseType: "blob",
  });

export default client;
